import { useTranslation } from 'libs/i18n'
import { useDevice, usePagination } from 'shared/hooks'
import { Table2 } from 'shared/components'
import { Pagination } from 'shared/atoms'
import { getCardTableStyles } from 'styles/table'
import { Product } from 'features/products'
import type { ProductItem, ProductsRes } from 'features/products/types/products.types'
import type { Option } from 'shared/components/ContextMenu/types'
import type { Select } from '@table-library/react-table-library/select'
import { useColumns } from '../hooks/useColumns'

type TableSectionProps = {
	products: ProductsRes
	isLoading: boolean
	select: Select
	getMenuOptions: (product: ProductItem) => Option[]
}

export const TableSection = ({
	products,
	isLoading,
	select,
	getMenuOptions
}: TableSectionProps) => {
	const { t } = useTranslation()
	const { isMobileOrTabletHorizontal } = useDevice()
	const { handlePagination } = usePagination()
	const columns = useColumns({ getMenuOptions })

	const results: ProductItem[] = products.data.results
	const tableStyles = getCardTableStyles(columns, { clickableRows: false })

	return (
		<>
			{isMobileOrTabletHorizontal ? (
				<ul className="divide-y divide-border">
					{results.map((product) => (
						<Product key={product.id} product={product} menuOptions={getMenuOptions(product)} />
					))}
				</ul>
			) : (
				<Table2
					className="mb-0 px-0 py-0 lg:flex lg:min-h-0 lg:flex-1 lg:flex-col"
					columns={columns}
					data={{ nodes: results }}
					isLoading={isLoading}
					select={select}
					customStyles={tableStyles}
				/>
			)}
			<div className="flex items-center justify-between gap-3 border-t border-border px-4 py-3 text-[11px] font-medium text-muted-foreground sm:px-5">
				<span>{t('{{ count }} products', { count: results.length })}</span>
				<Pagination
					prev={products.data.previous}
					next={products.data.next}
					onClick={handlePagination}
				/>
			</div>
		</>
	)
}
